import { render, staticRenderFns } from "./AmbassadorshipInvitation.vue?vue&type=template&id=b1be35ba"
import script from "./AmbassadorshipInvitation.vue?vue&type=script&lang=js"
export * from "./AmbassadorshipInvitation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports